// TODO: PostHog is temporarily disabled
// import posthog from 'posthog-js'

export function usePostHog() {
    // posthog.init('phc_T2eYlhWKoczhaqmnUfBI6gQWI9dgF8mHj0cxLDHjRi6', {
    //     api_host: 'https://eu.i.posthog.com',
    //     defaults: '2026-01-30'
    // })

    function identify(_user: {
        uuid: string
        email: string
        first_name: string | null
        last_name: string | null
        organization: string | null
    }) {
        // PostHog disabled — no-op
    }

    function reset() {
        // PostHog disabled — no-op
    }

    return { /* posthog, */ identify, reset }
}
